'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../constants/colors';
import * as overrides from 'reporting-data/lib/overrides';
const getDefaultTooltipOptions = () => fromJS({
  backgroundColor: null,
  useHTML: true,
  shadow: false,
  shape: 'square',
  borderColor: colors.TEXT_INACTIVE,
  borderWidth: 0,
  style: {
    padding: 0
  },
  followPointer: !overrides.disableHighchartsAnimation.enabled,
  animation: !overrides.disableHighchartsAnimation.enabled
});
export const defaultTooltipOptions = getDefaultTooltipOptions();